import React from 'react'
import { Route } from 'react-router-dom'
import PropTypes from 'prop-types'
import { GLOBALS } from './utils/Globals'
import ProtectedRoute from './components/ProtectedRoute'

import { Dashboard } from './pages/Dashboard'
import { UserDataList } from './pages/UserList'
import { CreateEditUser } from './pages/CreateEditUser'
import { CreateEditVirtualMachine } from './pages/CreateEditVirtualMachine'
import { VirtualMachineDataList } from './pages/VirtualMachineList'
import { CoursesList } from './pages/CoursesList'
import { CreateEditCourses } from './pages/CreateEditCourses'
import { CourseUses } from './pages/CourseUses'
import { CourseStudentUses } from './pages/CourseStudentUses'
import { ReservationDetails } from './pages/ReservationDetails'
import { PodsList } from './pages/PodsList'
import { CreateEditPods } from './pages/CreateEditPods'
import { CreateEditPrograms } from './pages/CreateEditPrograms'
import { LaboratoriesList } from './pages/LaboratoriesList'
import { ProgramList } from './pages/ProgramsList'
import { CreateEditLaboratories } from './pages/CreateEditLaboratories'
import { Laboratory } from './pages/ViewLaboratory'
import { Pod } from './pages/ViewPod'
import { Course } from './pages/ViewCourse'
import { Program } from './pages/ViewProgram'
import { CreateEditScheduler } from './pages/CreateEditScheduler'
import { ScheduleVisual } from './pages/ScheduleVisual'
import { RemoteResource } from './pages/ViewRemoteResource'
import { Reserve } from './pages/Reserve'
import { SuccessViewLab } from './pages/SuccessViewLab'

export const Routes = ({ userLogged }) => (
  <>
    <Route path={GLOBALS.menu.dashboard.link} exact component={Dashboard} />
    <Route path={GLOBALS.menu.profile.link} exact component={CreateEditUser} />

    <Route path="/viewlaboratory/:id" exact component={Laboratory} />
    <Route path="/viewpod/:id" exact component={Pod} />
    <Route path="/viewcourse/:id" exact component={Course} />
    <Route path="/viewprogram/:id" exact component={Program} />
    <Route path="/viewremoteresource/:id" exact component={RemoteResource} />
    <Route path="/successviewLab" exact component={SuccessViewLab} />

    <ProtectedRoute
      path={GLOBALS.menu.courses.linkList}
      exact
      component={CoursesList}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id, GLOBALS.roles.student.id, GLOBALS.roles.teacher.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={`${GLOBALS.menu.scheduler.link}/create`}
      exact
      component={CreateEditScheduler}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id, GLOBALS.roles.student.id, GLOBALS.roles.teacher.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={`${GLOBALS.menu.scheduler.link}/edit/:id`}
      exact
      component={CreateEditScheduler}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id, GLOBALS.roles.student.id, GLOBALS.roles.teacher.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={`${GLOBALS.menu.scheduler.link}/visual`}
      exact
      component={ScheduleVisual}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id, GLOBALS.roles.student.id, GLOBALS.roles.teacher.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={GLOBALS.menu.reserve.linkList}
      exact
      component={Reserve}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.student.id, GLOBALS.roles.admin.id, GLOBALS.roles.teacher.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={GLOBALS.menu.users.linkList}
      exact
      component={UserDataList}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={GLOBALS.menu.pods.linkList}
      exact
      component={PodsList}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={`${GLOBALS.menu.pods.link}/create`}
      exact
      component={CreateEditPods}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={`${GLOBALS.menu.pods.link}/edit/:id`}
      exact
      component={CreateEditPods}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={`${GLOBALS.menu.users.link}/create`}
      exact
      component={CreateEditUser}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={`${GLOBALS.menu.users.link}/edit/:id`}
      exact
      component={CreateEditUser}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={GLOBALS.menu.remoteresource.linkList}
      exact
      component={VirtualMachineDataList}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={`${GLOBALS.menu.remoteresource.link}/create`}
      exact
      component={CreateEditVirtualMachine}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={`${GLOBALS.menu.remoteresource.link}/edit/:id`}
      exact
      component={CreateEditVirtualMachine}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={`${GLOBALS.menu.courses.link}/create`}
      exact
      component={CreateEditCourses}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id, GLOBALS.roles.teacher.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={`${GLOBALS.menu.courses.link}/edit/:id`}
      exact
      component={CreateEditCourses}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id, GLOBALS.roles.teacher.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={`${GLOBALS.menu.courses.link}/uses/:id`}
      exact
      component={CourseUses}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id, GLOBALS.roles.student.id, GLOBALS.roles.teacher.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={`${GLOBALS.menu.courses.link}/uses/:courseId/student/:userId`}
      exact
      component={CourseStudentUses}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id, GLOBALS.roles.student.id, GLOBALS.roles.teacher.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={`${GLOBALS.menu.courses.link}/uses/:courseId/student/:userId/scheduler/:schedulerId`}
      exact
      component={ReservationDetails}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id, GLOBALS.roles.student.id, GLOBALS.roles.teacher.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={GLOBALS.menu.laboratories.linkList}
      exact
      component={LaboratoriesList}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id, GLOBALS.roles.teacher.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={`${GLOBALS.menu.laboratories.link}/create`}
      exact
      component={CreateEditLaboratories}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={`${GLOBALS.menu.laboratories.link}/edit/:id`}
      exact
      component={CreateEditLaboratories}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={GLOBALS.menu.programs.linkList}
      exact
      component={ProgramList}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={`${GLOBALS.menu.programs.link}/create`}
      exact
      component={CreateEditPrograms}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />

    <ProtectedRoute
      path={`${GLOBALS.menu.programs.link}/edit/:id`}
      exact
      component={CreateEditPrograms}
      userLogged={userLogged}
      allowedRoles={[GLOBALS.roles.admin.id]}
      redirectPath={GLOBALS.menu.dashboard.link}
    />
  </>
)

Routes.propTypes = { userLogged: PropTypes.object.isRequired }
